import React from 'react';
import FBLogo from './../../assets/facebook-ic.svg';
// import RedditLogo from './../../assets/reddit-ic.svg';
// import LinkedinLogo from './../../assets/linkedin-ic.svg';
import XLogo from './../../assets/x-logo.svg';
import YoutubeLogo from './../../assets/youtube-ic.svg';
import InstaLogo from './../../assets/insta-ic.svg';
import { Image } from 'antd';

const SocialSidebar = () => {
  const socialLinks = [
    { icon: YoutubeLogo, url: 'https://www.youtube.com/@SpotGenie_YT', color: 'text-red-500', alt: 'youtube-logo' },
    { icon: FBLogo, url: 'https://www.facebook.com/profile.php?id=61576442487260', color: 'text-blue-600', alt: 'fb-logo' },
    { icon: InstaLogo, url: 'https://www.instagram.com/spotgenie/', color: 'text-red-500', alt: 'youtube-logo' },
    { icon: XLogo, url: 'https://x.com/spotgenie', color: 'text-blue-400', alt: 'linkedin-logo' },
    // { icon: LinkedinLogo, url: 'https://linkedin.com', color: 'text-blue-400', alt: 'linkedin-logo' },
    // { icon: RedditLogo, url: 'https://www.reddit.com/user/Superb-Ad5189/', color: 'text-blue-700', alt: 'reddit-logo' }
  ];

  return (
    <div className="fixed right-0 top-1/3 transform -translate-y-1/2 z-50 bg-white shadow-lg rounded-l-lg">
      <div className="flex flex-col p-2 space-y-2">
        {socialLinks.map((social, index) => (
          <a 
            key={index} 
            href={social.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="md:p-2 py-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <Image
               src={social.icon}
               alt={social.alt}
               preview={false}
               className="!w-6 !h-6 object-contain hover:opacity-75 transition-opacity"
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialSidebar;